import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Edit2 } from "react-feather";
import { TaxUnit } from "../../../../../models";
import { thousandize } from "../../../../../util/formatting";
import { TaxUnitEditModal } from "../../TaxUnitModal/TaxUnitEditModal";
import { GenericList } from "../GenericList";
import { ListRow } from "../GenericListRow";
export const DKTaxUnitList: React.FC<{
  taxUnits: TaxUnit[];
  sumDonationsLabel: string;
  sumTaxDeductionsLabel: string;
  sumTaxBenefitLabel: string;
}> = t0 => {
  const $ = _c(33);
  const {
    taxUnits,
    sumDonationsLabel,
    sumTaxDeductionsLabel,
    sumTaxBenefitLabel
  } = t0;
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedTaxUnit, setSelectedTaxUnit] = useState(null);
  const unit = taxUnits[0];
  let t1;
  if ($[0] !== unit.ssn) {
    t1 = unit.ssn.length === 10 ? unit.ssn.replace(/(\d{6})(\d{4})/, "$1-$2") : unit.ssn.replace(/(\d{4})(\d{4})/, "$1 $2");
    $[0] = unit.ssn;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const suplementalInformation = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      label: "",
      width: "10%"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== sumDonationsLabel) {
    t3 = {
      label: sumDonationsLabel,
      width: "30%"
    };
    $[3] = sumDonationsLabel;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== sumTaxDeductionsLabel) {
    t4 = {
      label: sumTaxDeductionsLabel,
      width: "30%"
    };
    $[5] = sumTaxDeductionsLabel;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== sumTaxBenefitLabel) {
    t5 = {
      label: sumTaxBenefitLabel,
      width: "30%"
    };
    $[7] = sumTaxBenefitLabel;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = [t2, t3, t4, t5];
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const headers = t6;
  let rows;
  if ($[13] !== unit) {
    const filteredDeductions = unit.taxDeductions?.filter(_temp) || [];
    let t7;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <Edit2 size={16} />;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    const contextOptions = [{
      label: "Rediger",
      icon: t7
    }];
    let t8;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = (option, element) => {
        if (option === "Rediger") {
          setSelectedTaxUnit(element);
          setEditModalOpen(true);
        }
      };
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    const context = {
      contextOptions,
      onContextSelect: t8
    };
    rows = filteredDeductions.map((deductions, i) => {
      const row = {
        id: `${unit.id.toString()}${deductions.year}`,
        defaultExpanded: false,
        cells: [{
          value: deductions.year.toString()
        }, {
          value: thousandize(Math.round(deductions.sumDonations)) + " kr"
        }, {
          value: thousandize(Math.round(deductions.deduction)) + " kr"
        }, {
          value: thousandize(Math.round(deductions.benefit)) + " kr"
        }],
        element: unit
      };
      if (i === 0) {
        return {
          ...row,
          ...context
        };
      }
      return row;
    });
    const countDonations = Math.round(filteredDeductions.reduce(_temp2, 0));
    let t9;
    if ($[17] !== unit.id) {
      t9 = unit.id.toString();
      $[17] = unit.id;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    const totalsRow = {
      id: `${t9}total`,
      defaultExpanded: false,
      cells: [{
        value: "Totalt"
      }, {
        value: thousandize(countDonations) + " kr"
      }, {
        value: thousandize(Math.round(filteredDeductions.reduce(_temp3, 0))) + " kr"
      }, {
        value: thousandize(Math.round(filteredDeductions.reduce(_temp4, 0))) + " kr"
      }],
      element: unit
    };
    rows.push(countDonations > 0 ? totalsRow : {
      ...totalsRow,
      ...context
    });
    $[13] = unit;
    $[14] = rows;
  } else {
    rows = $[14];
  }
  let t7;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div>Der mangler information for skatteenheden.</div>;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div>{t7}<div>Kontakt os på <a href="mailto: donation@giveffektivt.dk">donation@giveffektivt.dk</a>.</div></div>;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const emptyPlaceholder = t8;
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [30, 60];
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== headers || $[23] !== rows || $[24] !== suplementalInformation || $[25] !== unit.name) {
    t10 = <GenericList title={unit.name} supplementalInformation={suplementalInformation} headers={headers} rows={rows} emptyPlaceholder={emptyPlaceholder} expandable={false} proportions={t9} />;
    $[22] = headers;
    $[23] = rows;
    $[24] = suplementalInformation;
    $[25] = unit.name;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== editModalOpen || $[28] !== selectedTaxUnit) {
    t11 = editModalOpen && selectedTaxUnit && <TaxUnitEditModal open={editModalOpen} initial={selectedTaxUnit} onClose={() => setEditModalOpen(false)} onSuccess={() => setEditModalOpen(false)} onFailure={_temp5} />;
    $[27] = editModalOpen;
    $[28] = selectedTaxUnit;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t10 || $[31] !== t11) {
    t12 = <>{t10}{t11}</>;
    $[30] = t10;
    $[31] = t11;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
};
function _temp(d) {
  return d.sumDonations > 0;
}
function _temp2(acc, cur) {
  return acc + cur.sumDonations;
}
function _temp3(acc_0, cur_0) {
  return acc_0 + cur_0.deduction;
}
function _temp4(acc_1, cur_1) {
  return acc_1 + cur_1.benefit;
}
function _temp5() {}